import { CurrencyId } from "@/services/currencies/currenciesTypes";
import { z } from "zod";

export const CurrencyId_Schema = z.enum(CurrencyId);
